import type { UniverseId } from '@/domain/universes/universe.interface';
import type { UniverseAvailableUnit } from '../../../interfaces/Unit.interface';
import { type Actions, ActionType } from './units.actions';
import { initialState, type State, unitAdapter } from './units.state';

export function unitsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_UNIT_DATA: {
            const universeAvailableUnits: Record<UniverseId, UniverseAvailableUnit[]> = action.payload.universeAvailableUnits.reduce(
                (acc, curr) => {
                    acc[curr.universeId] = acc[curr.universeId] ? [...acc[curr.universeId], curr] : [curr];
                    return acc;
                },
                {} as Record<UniverseId, UniverseAvailableUnit[]>
            );

            return unitAdapter.setAll(action.payload.units, {
                ...state,
                isLoaded: true,
                universeAvailableUnits
            });
        }

        case ActionType.RESET: {
            return {
                ...initialState
            };
        }

        default:
            return state;
    }
}
